import {faAngleLeft} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useNavigate} from 'react-router';

interface IProps {
  pageTitle: string;
  backUrl?: string;
}

const PageTitleParser = ({pageTitle, backUrl}: IProps) => {
  const navigate = useNavigate();

  const splittedTitle = pageTitle.split('/');
  const showTitle = splittedTitle.length > 1;
  const displayTitle = splittedTitle.slice(0, 1).map((title) => `${title}`.trim());

  const handlePageBack = () => {
    if (backUrl) {
      navigate(backUrl);
    }
  };

  return (
    <h2>
      <button disabled={!backUrl} onClick={handlePageBack}>
        {backUrl && <FontAwesomeIcon icon={faAngleLeft} />}
        {showTitle ? `${displayTitle}:` : `${displayTitle}`}
      </button>
      {showTitle && <span>{`${splittedTitle.splice(-1)}`}</span>}
    </h2>
  );
};

export default PageTitleParser;
